import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {SearchKeywordParam} from '../../common/shared/api/nicolas/params/SearchKeywordParam.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {CategoryTypeVo} from '../../common/shared/api/nicolas/vo/enums/CategoryTypeVo.enum';
import type {SearchKeywordResultVo} from '../../common/shared/api/nicolas/vo/SearchKeywordResultVo.interface';
import {SearchKeywordSortTypeVo} from '../../common/shared/api/nicolas/vo/SearchKeywordSortTypeVo.enum';

/**
 * 검색 키워드 결과 조회 (V2)
 *
 * V2에서는 응답 `list`에 세트상품이 혼합되어 반환된다. (type: SERIES | SET)
 * 참고: https://kakaoent.atlassian.net/wiki/spaces/PSD/pages/5044568674
 *
 * Origin: pageNicolasApi.getSearchKeyword
 * API: GET /api/v2/search/series
 */
export async function getSearchSeries(
  {
    keyword,
    categoryUid = CategoryTypeVo.None,
    showOnlyComplete,
    sortType: _sortType,
    page: _page,
    size: _size,
  }: SearchKeywordParam,
  options?: FetcherOptions
): Promise<ApiResultVo & {result: SearchKeywordResultVo}> {
  const page = _page || 0;
  const size = _size || 25;
  const sortType = _sortType || SearchKeywordSortTypeVo.Accuracy;

  const response = await axiosBffFetch(
    '/api/gateway/api/v2/search/series',
    {
      method: 'GET',
      params: {
        keyword,
        category_uid: categoryUid,
        is_complete: !!showOnlyComplete,
        sort_type: sortType,
        page,
        size,
      },
    },
    options
  );

  return response.data;
}
